<template>
  <div>
    <v-flex xs12>
      <v-progress-circular
        size="150"
        :width="10"
        :rotate="-90"
        :value="parseInt(profile.completion)"
        :color="
          profile.complete === false ? themes.client.light.warning : themes.client.light.primary
        "
      >
        <v-avatar size="140">
          <img v-img-orientation-changer v-if="profile.avatar" :src="profile.avatar || '/img/missing/avatars/original.png'" />
        </v-avatar>
      </v-progress-circular>
    </v-flex>
    <v-flex class="headline mt-2">
      <span v-if="profile.firstNames">{{ profile.firstNames }}</span>
      <span v-if="profile.lastName">&nbsp;{{ profile.lastName }}</span>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: { profile: { type: Object, required: true } },
}
</script>
